import React, { createContext } from 'react'

export const NavbarContext = createContext();